import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../Auths/CheckUser.js";
import Swal from "sweetalert2";


const ArreaListPage = () => {
  const { user } = useAuth();
  const [clients, setClients] = useState([]);

  useEffect(() => {
    if (!user) return;

    const fetchUser = async () => {
      try {
        const res = await axios.get(`https://bpohasil.ngrok.app/api/user/${user.id}`);
        // console.log("Fetched user:", res.data);

        // Set clients safely
        setClients(Array.isArray(res.data.arreas) ? res.data.arreas : []);
      } catch (error) {
        console.error(error);
        Swal.fire("Error", "Failed to load user data", "error");
      }
    };

    fetchUser();
  }, [user]);

 

  return (
  
      <div className="mt-4">
        <h2 className="text-xl font-bold mb-4">Arreas : {clients.length || 0}</h2>

        {clients.length === 0 ? (
          <p className="text-gray-500">No Arrea assigned.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {clients.map((client,index) => (
              <div
                key={index}
               
                className="p-4 border rounded-lg shadow-sm cursor-pointer hover:bg-gray-100"
              >
                <p className="font-semibold text-gray-700">
                  <span className="text-black">Arrea : </span> {client.ArreaName}
                </p>
                <p className="text-sm text-gray-600">Arrea ID: {client.ArreaId}</p>
              </div>
            ))}
          </div>
        )}

       
      </div>
  );
};

export default ArreaListPage;
